import axios from "axios";

export default {
    namespaced: true,

    state: {
        newestRegionalWordOfTheWeek: {},
    },

    getters: {
        newestRegionalWordOfTheWeek(state) {
            return state.newestRegionalWordOfTheWeek;
        },
    },

    mutations: {
        SET_NEWEST_REGIONAL_WORD_OF_THE_WEEK(
            state,
            newestRegionalWordOfTheWeek
        ) {
            state.newestRegionalWordOfTheWeek = newestRegionalWordOfTheWeek;
        },
    },

    actions: {
        async getNewestRegionalWordOfTheWeek({ commit }) {
            await axios
                .get("/api/newest-regional-word-of-the-week")
                .then((response) => {
                    commit(
                        "SET_NEWEST_REGIONAL_WORD_OF_THE_WEEK",
                        response.data
                    );
                });
        },
    },
};
